import { useAccessResource } from "./useAccessResource";
import { creatorAlbumAccessService } from "../services/creatorAlbumAccessService";

export const useCreatorAlbumAccess = (username, userId) =>
  useAccessResource(username, userId, creatorAlbumAccessService);
